const pad = (number) => {
  return number < 10 ? '0' + number : number
}

const convertToIso = (date) => {
  if (!Date.prototype.toLocalISOString) {
    Date.prototype.toLocalISOString = function() {
      return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        '.' + (this.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
    }
  }
  return date.toLocalISOString()
}

export default convertToIso



// WEBPACK FOOTER //
// ./src/scripts/modules/local-iso-string.js